import { render } from "./ProfitChart.vue?vue&type=template&id=421d85d7&scoped=true"
import script from "./ProfitChart.vue?vue&type=script&lang=js"
export * from "./ProfitChart.vue?vue&type=script&lang=js"

import "./ProfitChart.vue?vue&type=style&index=0&id=421d85d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421d85d7"]])

export default __exports__